import React, { useMemo, useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import * as XLSX from "xlsx";
import Button from "../../components/utils/Button";
import Table from "../../components/utils/Table";
import Modal from "../../components/utils/Modal";
import CardLayout from "../../components/utils/CardLayout";
import { useDispatch, useSelector } from "react-redux";
import reportActions from "../../redux/reports/actions";
import genericActions from "../../redux/generic/actions";
import QRCode from "react-qr-code";
import { downloadExcelSampleFile } from "../../helpers/commonFunction";
const { getACode } = genericActions;
const { getTransactionReports, resetMessage } = reportActions;


const ActivationReport = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const { aCodeList } = useSelector(state => state.generic);
  const [searchItem, setSearchItem] = useState("");
  const [showQRModal, setShowQRModal] = useState(false);
  const [selectedQrData, setSelectedQrData] = useState({});
  const today = new Date();
  const beforeTwoDays = new Date();
  beforeTwoDays.setDate(beforeTwoDays.getDate() - 2);
  const formatDate = (date) => date.toISOString().split("T")[0];
  const { transactionReports, transactionReportsLoading, } = useSelector((state) => state.reports)
  const { defaultCurrency } = useSelector((state) => state.auth);



  const { register, handleSubmit, reset, formState: { errors } } = useForm({
    mode: "onChange",
    defaultValues: {
      distributorID: "",
      serialNumber: "",
      txnid: "",
      msisdn: "",
      status: "",
      fromDate: formatDate(beforeTwoDays),
      toDate: formatDate(today),
      isReporttype: 1,
    },
  });

  useEffect(() => {
    dispatch(getACode());
    dispatch(getTransactionReports({
      fromDate: formatDate(beforeTwoDays),
      toDate: formatDate(today),
      isReporttype: 1,
    }));
  }, [dispatch]);


  const statusList = [
    {
      value: "",
      label: "All Status"
    },
    {
      value: "15",
      label: "Success"
    },
    {
      value: "16",
      label: "Failed"
    }
  ];

  const columns = [
    { displayName: "Transaction Type", key: "transactionType" },
    { displayName: "Serial Number", key: "serialNumber" },
    { displayName: "Transaction ID", key: "txnid" },
    { displayName: "Mobile Number", key: "msisdn" },
    { displayName: "Transaction Date", key: "transactionDate" },
    { displayName: "Plan Name", key: "planName" },
    { displayName: "Plan Amount", key: "planAmount" },
    { displayName: "Charge Amount", key: "chargeAmount" },
    { displayName: "Profit", key: "profit" },
    { displayName: "Validity Days", key: "validity" },
    { displayName: "Status", key: "status" },
    { displayName: "QR Code", key: "LPA" },
    { displayName: "Account Number", key: "accountNumber" },
    { displayName: "PIN", key: "pin" },
  ];

  const filteredItems = useMemo(() => {
    return Array.isArray(transactionReports) && transactionReports.length > 0
      ? transactionReports.filter(item => {
        if (!searchItem) return true;
        return Object.values(item).some(val => typeof val === "string" && val.toLowerCase().includes(searchItem.toLowerCase()));
      })
      : [];
  }, [transactionReports, searchItem]);

  const rowData = useMemo(() => {
    return (filteredItems || []).map((item) => ({
      transactionType: item["TransactionType"],
      serialNumber: item["SerialNumber"],
      txnid: item["TransactionID"],
      msisdn: item["MobileNumber"],
      transactionDate: item["TransactionDate"],
      planName: item["PlanName"],
      planAmount: defaultCurrency + '' + item["PlanAmount"],
      chargeAmount: defaultCurrency + '' + item["ChargeAmount"],
      profit: defaultCurrency + '' + item["Profit"],
      validity: item["ValidityDays"],
      accountNumber: item["AccountNumber"],
      pin: item["PIN"],
      LPA: <div style={{ display: "flex", justifyContent: "center", cursor: "pointer", }} onClick={() => handleQRClick(item)}> <QRCode value={item["LPA"]} size={25} /> </div> || "-",
      status: item["Status"] === "Success" ? (<span className="badge bg-success">{item["Status"]}</span>) : (<span className="badge bg-danger">{item["Status"]}</span>),

    }));
  }, [filteredItems]);


  const onSubmit = (data) => {
    const payload = {
      ...data,
      distributorID: Number(data.distributorID || 0)
    }
    dispatch(getTransactionReports(payload));
  };

  const handleQRClick = (data) => {
    setSelectedQrData(data);
    setShowQRModal(true);

  };
  const handleCloseQR = () => {
    setShowQRModal(false);
    setSelectedQrData({});
  };

  const handleReset = () => {
    reset({
      distributorID: "",
      serialNumber: "",
      txnid: "",
      msisdn: "",
      status: "",
      fromDate: formatDate(beforeTwoDays),
      toDate: formatDate(today),
    });
    dispatch(resetMessage());
  };


  const handleExportExcel = () => {
    const data = filteredItems.map(item => ({
      "Transaction Type": item["TransactionType"],
      "Serial Number": item?.SerialNumber,
      "Transaction ID": item?.TransactionID,
      "Mobile Number": item["MobileNumber"],
      "Transaction Date": item?.TransactionDate,
      "Plan Name": item?.PlanName,
      "Plan Amount": defaultCurrency + '' + item["PlanAmount"],
      "Charge Amount": defaultCurrency + '' + item["ChargeAmount"],
      "Profit": defaultCurrency + '' + item?.Profit,
      "Validity": item["ValidityDays"],
      "Status": item["Status"],
      "LPA": item?.LPA,
      "Account Number": item?.AccountNumber,
      "PIN": item?.PIN,
    }))

    downloadExcelSampleFile(data, "activation-report.xlsx");
  };


  return (
    <>
      {/* <Loader/>  */}
      <CardLayout
        title="Activation Report"
        icon="ri-file-chart-line "
        rightContent={
          <Button
            title="Excel"
            buttonType="button"
            variant="secondary"
            onClick={handleExportExcel}
            icon={<i className="ri-download-cloud-line me-2" />}
          />}
      >
        <div>
          {/* Body */}
          <form onSubmit={handleSubmit(onSubmit)}>
            <div
              className="row"

            >
              {/* ACode */}
              <div className="col-lg-2 col-md-4">
                <label className="form-label fw-semibold">ACode</label>
                <select
                  className="form-select"
                  {...register("distributorID")}
                >
                  <option value="">Select ACode</option>

                  {aCodeList?.map((item) => (
                    <option
                      key={item.Id}
                      value={item.Id}
                    >
                      {item.ACode}
                    </option>
                  ))}
                </select>
              </div>

              {/* Serial Number */}
              <div className="col-lg-2 col-md-4">
                <label className="form-label fw-semibold">Serial Number</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Serial Number"
                  {...register("serialNumber")}
                />
              </div>

              {/* Transaction ID */}
              <div className="col-lg-2 col-md-4">
                <label className="form-label fw-semibold">Transaction ID</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Transaction ID"
                  {...register("txnid")}
                />
              </div>

              {/* Mobile Number */}
              <div className="col-lg-2 col-md-4">
                <label className="form-label fw-semibold">Mobile Number</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Mobile Number"
                  {...register("msisdn")}
                />
              </div>

              {/* From Date */}
              <div className="col-lg-2 col-md-4">
                <label className="form-label fw-semibold">From Date</label>
                <input
                  type="date"
                  className="form-control"
                  {...register("fromDate")}
                />
              </div>

              {/* To Date */}
              <div className="col-lg-2 col-md-4">
                <label className="form-label fw-semibold">To Date</label>
                <input
                  type="date"
                  className="form-control"
                  {...register("toDate")}
                />
              </div>

              {/* Status */}
              <div className="col-lg-2 col-md-4">
                <label className="form-label fw-semibold">Status</label>
                <select className="form-select"
                  {...register("status")}>
                  {statusList.map((item, index) => (
                    <option key={index} value={item.value}>
                      {item.label}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-lg-3 col-md-6 d-flex align-items-end gap-3" style={{ height: '70px' }}>
                {/* Buttons */}
                <Button
                  title="Get Report"
                  buttonType="submit"
                  variant="primary"
                  disable={transactionReportsLoading}
                  loading={transactionReportsLoading}
                  icon={<i className="ri-search-line me-2"></i>}
                  style={transactionReportsLoading ? { width: '46.5%', padding: '10px 2px' } : {}}
                />

                <Button
                  title="Reset"
                  buttonType="button"
                  variant="secondary"
                  onClick={handleReset}
                  icon={<i className="ri-refresh-line me-2"></i>}
                />
              </div>
               <div className="col-lg-3 offset-lg-4 col-md-4 d-flex align-items-end" style={{ height: '70px' }}>
                <input
                  type="search"
                  onChange={(e) => setSearchItem(e.target.value)}
                  className="form-control form-control-sm"
                  placeholder="Search..."
                />
              </div>
            </div>
          </form>

          {/* Search Form end */}

        </div>
        {/* Table */}
        <div className="mt-2">
          <Table
            columns={columns}
            data={rowData}
            pagination
            loading={transactionReportsLoading}
            // loading={true}
            tableHeight="270px"
          />

        </div>

        <Modal
          title={selectedQrData?.TransactionID || 'QR Code'}
          showModal={showQRModal}
          onHide={handleCloseQR}
          showFooter={false}
          width={320}
        >
          <div className="d-flex justify-content-center py-3">
            <div
              className="p-3"
              style={{
                display: "flex",
                justifyContent: "center",
                borderRadius: "15px",
                boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
              }}
            >
              {selectedQrData?.LPA && (
                <QRCode
                  value={selectedQrData?.LPA}
                  size={180}
                />
              )}
            </div>
          </div>
        </Modal>
      </CardLayout>
    </>
  );
};

export default ActivationReport;
